export const actions = {
  setTrack({ commit }, payload) {
    commit("SET_TRACK", payload);
  }
};
